import { createContext, useContext } from "react";
import axios from "axios";

const PdfContext = createContext();

export const PdfProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const downloadStockPDF = async (payload, fileName = "report") => {
    try {
      const res = await axios.post(`${BASE_URL}/api/generate-pdf`, payload, {
        responseType: "blob", // 🔥 VERY IMPORTANT
      });

      // 🔥 Create download
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", `${fileName}.pdf`);

      document.body.appendChild(link);
      link.click();
      link.remove();
      return true;
    } catch (err) {
      console.error("PDF download failed", err);
      throw err;
    }
  };

  return (
    <PdfContext.Provider value={{ downloadStockPDF }}>
      {children}
    </PdfContext.Provider>
  );
};

export const usePdf = () => useContext(PdfContext);
